export default {
  selection: (state) => {
    return state.categories.map((category) => {
      const selectedNominee = state.selected.find(
        ({ categoryId }) => parseInt(categoryId) === parseInt(category.id)
      )
      return {
        category,
        nominee: selectedNominee
          ? // ? state.nominees.find(nominee => nominee.id === selectedNominee.nomineeId)
            state.nominees.find(
              (nominee) => nominee.id === selectedNominee.nomineeId && nominee.category.id === category.id
            )
          : null,
        suggestion:
          selectedNominee && typeof selectedNominee.suggestionName !== 'undefined' ? selectedNominee : null,
      }
    })
  },

  getNomineesByCategoryId: (state) => (categoryId) => {
    return state.nominees
      .filter(({ category }) => category.id === categoryId)
      .sort((a, b) => a.name.localeCompare(b.name))
  },

  getFilteredNomineesByCategoryId: (state, getters) => (categoryId) => {
    const filtered = getters.getNomineesByCategoryId(categoryId)

    return filtered.sort((a, b) => 0.5 - Math.random())
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js